export const colors = {
  primary: "#12197b",
  secondary: "#fd6601",
};
